// src/config.js
export const BASE_URL = "https://api.scalpxedge.com";